import { BreadCrumb, Button, Title } from "@funcional/react-ui";
import { Private, SsoRolesEnum } from "@funcional/react-auth-ui";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@material-ui/core";
import UploadFileProductGroupRules from "@upload/storage/pages/UploadFileProductGroupRules";
import { useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import CloseIcon from "@material-ui/icons/Close";
import { Grid } from "@material-ui/core";
import { useDownloadCsvModelProductGroupRules } from "../hooks/useDownloadCsvModelProductGroupRules";
import { useSendFileProductGrouptoJobRule } from "../hooks/useSendFileProductGrouptoJobRule";

export default function RegisterLoadProductGroupRules() {
  let { programCode }: { programCode: string } = useParams();
  const history = useHistory();

  const [displayFormFieldModal, setDisplayFormFieldModal] = useState(false);
  const [nameFileUpload, setNameFileUpload] = useState("");
  const [messageErroDownload, setMessageErroDownload] = useState("");

  const { mutateAsync } = useDownloadCsvModelProductGroupRules();
  const mutationSendFile = useSendFileProductGrouptoJobRule();

  const downloadCsvModelProductGroupRules = async () => {
    try {
      const { url } = await mutateAsync();

      if (url) {
        const link = document.createElement("a");
        link.download = url;
        link.href = url;
        link.click();
      }
    } catch (err) {
      console.error(err);
      setMessageErroDownload(
        "Erro ao efetuar o download, por favor tente mais tarde"
      );
    }
  };

  const openModal = () => {
    setDisplayFormFieldModal(true);
  };

  const closeModal = () => {
    setDisplayFormFieldModal(false);
  };

  const nameFileUploadModal = (name: string) => {
    setNameFileUpload(name);
  };

  const confirmLoadProductGroupRules = async () => {
    try {
      const result = await mutationSendFile.mutateAsync({
        input: { fileName: nameFileUpload, programID: programCode },
      });

      history.push(
        `/pbm/programs/${programCode}/loadproductgrouprules/confirm/${result.processed}`
      );
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="flex items-center w-full">
        <div className="flex-1">
          <Title marginBottom={0}>Carga de regras de grupo de produtos</Title>
        </div>

        <div className="flex-shrink-0 space-x-2">
          <Private
            roles={[
              SsoRolesEnum.MASTER,
              SsoRolesEnum.SUPPORT,
              SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
              SsoRolesEnum.RETAIL_PHARMA_BENEFIT_MANAGER,
            ]}
          >
            {!messageErroDownload ? (
              <>
                <Button
                  variant="text"
                  color="primary"
                  onClick={downloadCsvModelProductGroupRules}
                >
                  Baixar planilha modelo
                </Button>
              </>
            ) : (
              <>
                <b>{messageErroDownload}</b>
              </>
            )}
          </Private>
          <Private
            roles={[
              SsoRolesEnum.MASTER,
              SsoRolesEnum.SUPPORT,
              SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
              SsoRolesEnum.RETAIL_PHARMA_BENEFIT_MANAGER,
            ]}
          >
            <Button onClick={openModal} color="primary">
              Carga de regras
            </Button>
          </Private>
        </div>
      </div>

      <BreadCrumb
        items={[
          { path: "/pbm/programs", label: "Programas" },
          {
            path: `/pbm/programs/${programCode}`,
            label: programCode,
          },
          { label: "Carga de regras de grupo de produtos" },
        ]}
      />

      <Dialog
        fullWidth
        open={displayFormFieldModal}
        onClose={() => setDisplayFormFieldModal(false)}
      >
        <DialogTitle>
          <div className="flex flex-row justify-between">
            <h1 className="mt-1 text-3xl font-bold text-gray-600">
              Upload de Arquivo
            </h1>
            <div>
              <IconButton aria-label="close" onClick={closeModal}>
                <CloseIcon />
              </IconButton>
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <UploadFileProductGroupRules
            closeModal={closeModal}
            nameFileUploadModal={nameFileUploadModal}
          />
        </DialogContent>
        <DialogActions>&nbsp;</DialogActions>
      </Dialog>

      <Grid container>
        <Grid item>
          <h6 className="mb-4 font-medium text-gray-500 text-md">
            Passo a passo para a carga de regras
          </h6>

          <ol className="px-1 py-1 text-sm text-gray-500 list-decimal list-inside whitespace-nowrap">
            <li>Baixe a planilha modelo</li>
              <li>Preencha os dados</li>
              <ul className="ml-3.5">
                  <b>
                    As duas primeiras linhas do arquivo serão
                    desconsideradas (Título e explicação)
                  </b>  
              </ul>
            <li>Faça o upload do arquivo CSV</li>
            <li>Confirme a carga de regras</li>
          </ol>
        </Grid>
      </Grid>

      <div className="flex justify-end">
        <Button
          color="primary"
          onClick={confirmLoadProductGroupRules}
          disabled={!nameFileUpload}
        >
          Confirmar carga de regras
        </Button>
      </div>
    </>
  );
}
